// extracted by mini-css-extract-plugin
export default {"eventCard":"Profile_eventCard__RMznS"};